import { useEffect, useState } from "react";
import { base64ToBlob } from "../../../../../../../configurations/Helpers/Fileshelper";
import useAxios from "../../../../../../../context/AxiosContext/AxiosContext";
import { useFirebase } from "../../../../../../../context/FirebaseContext/FirebaseContext";
import { isProduction } from "../../../../../../../configurations/Axios/Clients";
import { UserSignature, UsersFiltered, PhysycalPaymentValidateUser } from "../../../../../../../configurations/Axios/urls";
import { useAuth } from "../../../../../../../context/AuthContext/AuthContext";
const useAuthorization = ({ onAutorizationDone, userAuthorized }: any) => {
  const { firebasestorage } = useFirebase();
  const { user } = useAuth();
  const { VisitaxPut, VisitaxGet, VisitaxPost } = useAxios();
  const [usersList, setUsersList] = useState([]);
  const [originalusersList, setoriginalUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(userAuthorized);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [AuthError, setAuthError] = useState(false);
  const [SignatureOpen, setSignatureOpen] = useState(false);

  const handleUserChange = (event: any, value: any) => {
    event;
    setSelectedUser(value);
  };

  const handlePasswordChange = (event: any) => {
    setPassword(event.target.value);
  };

  const handleAuthorize = () => {
    setLoading(true);
    validateuser();
  };

  const FailAutorization = () => {
    onAutorizationDone({ state: false, user: selectedUser });
    setLoading(false);
    setAuthError(true);
  }
  const DoneAuthorization = (signature: any) => {
    onAutorizationDone({ state: true, user: { ...selectedUser, signature: signature } });
    setLoading(false);
    setAuthError(false);
  }

  const UpdateUserSignature = (Signature: any, idUser: any, fullname: any) => {
    try {

      const filepath = !isProduction()
        ? "UsersSandox/" + idUser + "/Signature" + fullname
        : "Users/" + idUser + "/Signature" + fullname;
      firebasestorage.uploadFile(base64ToBlob(Signature), filepath)
        .then((urlpicture) => {
          const onSuccesSignatureUpdate = (response: any) => {
            if (response.status == 200) {
              DoneAuthorization(urlpicture);
              return;
            }
            FailAutorization();
          };
          const uploadSignaturePayload = {
            id: idUser,
            signature: urlpicture,
          };
          VisitaxPut(UserSignature + "/" + idUser, uploadSignaturePayload, onSuccesSignatureUpdate);
        })
        .catch((e: any) => {
          console.log(e);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const onokResponse = (response: any) => {
      if (response.status == 200) {
        const users = response.data.data;
        setoriginalUsersList(users);
        const filterAndTransformUsers = (users: any) => {
          return users
            // .filter(
            //   (user: any) =>
            //     user.role === "Supervisor" && user.userName.includes("itedesca")
            // )
            .map((user: any) => ({
              fullname: `${user.name} ${user.lastName} ${user.motherLastName} ${user.fatherLastName}`,
              id: user.id,
            }));
        };
        const filteredUsers = filterAndTransformUsers(users);
        setUsersList(filteredUsers);
      };
      return
    }
    setUsersList([]);
    VisitaxGet(UsersFiltered + "?SUP=true&ASE=false&Active=true&&DR=false", onokResponse);
  }, []);

  const validateuser = () => {
    const onokResponse = (response: any) => {

      if (response.status == 200) {
        let userselected: any = {}
        if (selectedUser.id === user?.id) {
          userselected = user;
        }
        else {
          userselected = originalusersList.find(
            (usuario: any) => usuario.id === selectedUser.id
          );
        }
        if (userselected?.signature) {
          DoneAuthorization(userselected?.signature);
        } else {

          setSignatureOpen(true);
        }
        return;
      }
      if (response) {
        FailAutorization();
      }
    };
    VisitaxPost(PhysycalPaymentValidateUser, {
      idUser: selectedUser.id,
      password: password,
    }, onokResponse)


  };



  return {
    setAuthError,
    AuthError,
    usersList,
    password,
    loading,
    selectedUser,
    SignatureOpen,
    handleUserChange,
    handleAuthorize,
    handlePasswordChange,
    setSignatureOpen,
    validateuser,
    UpdateUserSignature,
  };
};
export default useAuthorization;
